import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import Switch from "../../components/Switch";
import CopyCommand from "../../components/CopyCommand";

const ShowHtmlDoc = () => {
  const navigate = useNavigate();
  const { id, name } = useParams(); // Get the HTML document ID from the URL

  const [data, setData] = useState([]); // Initialize as an empty array
  const [count, setCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalFile, setModalFile] = useState("");
  const [message, setMessage] = useState("");
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [dragResult, setDragResult] = useState(null);

  // State for Send Modal
  const [showSendModal, setShowSendModal] = useState(false);
  const [sendType, setSendType] = useState("single");
  const [merchants, setMerchants] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState("");
  const [loadingMerchants, setLoadingMerchants] = useState(false);
  const [posList, setPosList] = useState([]);
  const [selectedPosId, setSelectedPosId] = useState("");
  const [loadingPos, setLoadingPos] = useState(false);
  const [selectedHtmlDocInfoId, setSelectedHtmlDocInfoId] = useState(null);
  const [isSending, setIsSending] = useState(false);

  // Group States
  const [groupList, setGroupList] = useState([]);
  const [selectedSubGroupshtmldoc, setSelectedSubGroupshtmldoc] = useState([]);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Fetch HTML document info data
  const fetchData = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = {
      htmldocid: id,
    };

    try {
      const response = await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/Search',
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setData(response.data.data.sort((a, b) => a.position - b.position));
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(); // Ensure fetchData is called on component mount
  }, []);

  const handleSwitch = async () => {
    if (!dragResult || !dragResult.destination) return; // Check if dragResult is available

    setIsPopUpOpen(false);

    const reorderedItems = Array.from(data);
    const [movedItem] = reorderedItems.splice(dragResult.source.index, 1);
    reorderedItems.splice(dragResult.destination.index, 0, movedItem);

    // Update positions
    const updatedItems = reorderedItems.map((item, index) => ({
      id: item.id,
      position: index + 1,
    }));

    const requestBody = { list: updatedItems };

    try {
      const token = getCookie("token");
      const userid = getCookie("userid");

      if (!token || !userid) {
        console.error("Missing token or userId in localStorage");
        return;
      }

      await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/UpdatePosition',
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      setMessage("Positions updated successfully!");

      // Call fetchData again to refresh the list after switching
      fetchData();
    } catch (error) {
      console.error("Error updating positions:", error);
      setMessage("Failed to update positions.");
    }
  };

  const handleAddPop = () => {
    navigate(`/addhtmlDocFile/${id}/${name}`);
  };

  const handlePreview = (itemId) => {
    navigate(`/previewhtmldocinfo/${itemId}`);
  };

  const handleDownload = async (item) => {
    if (!item.filepath) {
      alert("File path not available");
      return;
    }

    try {
      // Fetch the HTML file
      const response = await fetch(item.filepath);
      const htmlContent = await response.text();

      // Create a blob with the HTML content
      const blob = new Blob([htmlContent], { type: 'text/html' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Use the filename from item or create a default one
      const filename = item.filename || `html_${item.id}_${item.name}.html`;
      link.download = filename;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Failed to download file");
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    setDragResult(result); // Store the result in the state
    setIsPopUpOpen(true); // Open the confirmation popup
  };

  const handleFileClick = (image) => {
    setModalFile(image);
    setShowModal(true);
  };

  const handleToggle = async (e, item) => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const apiUrl = item.active
      ? 'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/UpdateStatus/Deactive'
      : 'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/UpdateStatus/Active';

    const requestBody = { id: item.id };

    try {
      await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      // Update the state to reflect the change
      setData(
        data.map((d) => (d.id === item.id ? { ...d, active: !item.active } : d))
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handlePosition = async (id, direction) => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = { id: id, direction: direction };

    try {
      await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/SwitchPosition',
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );
      setMessage("Position updated successfully!");
      fetchData();
    } catch (error) {
      console.error("Error updating position:", error);
      setMessage("Failed to update position.");
    }
  };

  const handleUpdatePop = (id1) => {
    navigate(`/updatehtmlDocFile/${id1}/${id}/${name}`);
  };

  const handleDelete = async (id) => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = { id: id };

    try {
      await axios.post(
        'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/Delete',
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );
      // Refetch the data after delete to refresh the list
      setCount(count + 1);
      fetchData();
      setMessage("Data deleted successfully!");
    } catch (error) {
      console.error("Error deleting item:", error);
      setMessage("Failed to delete data");
    }
  };

  const handleSendButtonClick = (htmlDocInfoId) => {
    setSelectedHtmlDocInfoId(htmlDocInfoId);
    setShowSendModal(true);
    setSendType("single");
    setMerchants([]);
    setSelectedMerchant("");
    setPosList([]);
    setSelectedPosId("");
    fetchMerchants();
  };

  const fetchMerchants = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    setLoadingMerchants(true);
    try {
      const response = await axios.get(
        "https://api.dqr-display-tms.bonrix.in/api/POSOperation/GetDistinct/merchantid",
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "accept": "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setMerchants(response.data.data);
      } else {
        setMerchants([]);
      }
    } catch (error) {
      console.error("Error fetching merchants:", error);
    } finally {
      setLoadingMerchants(false);
    }
  };

  const handleSendTypeChange = (e) => {
    const type = e.target.value;
    setSendType(type);
    if (type === "single") {
      fetchMerchants();
    } else if (type === "group") {
      fetchGroupAndSubGroup();
    }
  };

  const fetchGroupAndSubGroup = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    setLoadingGroups(true);
    try {
      const response = await axios.get(
        "https://api.dqr-display-tms.bonrix.in/api/SubGroupOperation/GroupAndSubGroup",
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "accept": "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setGroupList(response.data.data);
      } else {
        setGroupList([]);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
      setGroupList([]);
    } finally {
      setLoadingGroups(false);
    }
  };

  // Handle group selection (select all subgroups in a group)
  const handleGroupSelect = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata) return;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    const allSelected = subgroupIds.every((id) =>
      selectedSubGroupshtmldoc.includes(id)
    );

    if (allSelected) {
      // Deselect all subgroups in this group
      setSelectedSubGroupshtmldoc(
        selectedSubGroupshtmldoc.filter((id) => !subgroupIds.includes(id))
      );
    } else {
      // Select all subgroups in this group
      const newSelection = [...selectedSubGroupshtmldoc];
      subgroupIds.forEach((id) => {
        if (!newSelection.includes(id)) {
          newSelection.push(id);
        }
      });
      setSelectedSubGroupshtmldoc(newSelection);
    }
  };

  // Handle individual subgroup selection
  const handleSubGroupSelect = (subgroupId) => {
    if (selectedSubGroupshtmldoc.includes(subgroupId)) {
      setSelectedSubGroupshtmldoc(
        selectedSubGroupshtmldoc.filter((id) => id !== subgroupId)
      );
    } else {
      setSelectedSubGroupshtmldoc([...selectedSubGroupshtmldoc, subgroupId]);
    }
  };

  // Check if all subgroups in a group are selected
  const isGroupFullySelected = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata || group.subgroupdata.length === 0)
      return false;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    return subgroupIds.every((id) => selectedSubGroupshtmldoc.includes(id));
  };

  // Check if some (but not all) subgroups in a group are selected
  const isGroupPartiallySelected = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata || group.subgroupdata.length === 0)
      return false;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    const selectedCount = subgroupIds.filter((id) =>
      selectedSubGroupshtmldoc.includes(id)
    ).length;

    return selectedCount > 0 && selectedCount < subgroupIds.length;
  };

  // Get selected subgroup names for display
  const getSelectedSubGroupNames = () => {
    const names = [];
    groupList.forEach((group) => {
      if (group.subgroupdata) {
        group.subgroupdata.forEach((sg) => {
          if (selectedSubGroupshtmldoc.includes(sg.id)) {
            names.push(sg.name);
          }
        });
      }
    });
    return names;
  };

  const fetchPosByMerchant = async (merchantName) => {
    if (!merchantName) {
      setPosList([]);
      return;
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    setLoadingPos(true);
    try {
      const response = await axios.get(
        `https://api.dqr-display-tms.bonrix.in/api/POSOperation/GetDistinct/specificmerchantid/${merchantName}`,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "accept": "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setPosList(response.data.data);
      } else {
        setPosList([]);
      }
    } catch (error) {
      console.error("Error fetching POS details:", error);
      setPosList([]);
    } finally {
      setLoadingPos(false);
    }
  };

  const handleMerchantChange = (e) => {
    const merchantName = e.target.value;
    setSelectedMerchant(merchantName);
    setSelectedPosId(""); // Reset POS selection
    fetchPosByMerchant(merchantName);
  };

  const closeSendModal = () => {
    setShowSendModal(false);
  };

  const handleSetToDevice = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const isGroup = sendType === "group";
    const apiUrl = isGroup
      ? "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SG/HtmlDoc/Single"
      : "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/HtmlDoc/Single";

    const requestBody = isGroup
      ? {
        subgroupids: selectedSubGroupshtmldoc.map(id => parseInt(id)),
        htmldocid: parseInt(id),
        htmldocinfoid: parseInt(selectedHtmlDocInfoId),
      }
      : {
        merchantname: selectedMerchant,
        posid: parseInt(selectedPosId),
        htmldocid: parseInt(id),
        htmldocinfoid: parseInt(selectedHtmlDocInfoId),
      };

    if (!isGroup && (!selectedMerchant || !selectedPosId)) {
      setMessage("Please select merchant and POS");
      return;
    }

    if (isGroup && selectedSubGroupshtmldoc.length === 0) {
      setMessage("Please select at least one SubGroup");
      return;
    }

    setIsSending(true);
    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
          accept: "text/plain",
        },
      });

      if (response.data && response.data.isresponse) {
        const sendResult = response.data.sendresult?.[0];
        if (sendResult) {
          setMessage(sendResult.errormsg || "Sent to device!");
        } else {
          setMessage("Sent to device successfully!");
        }

        // Auto close after 3 seconds
        setTimeout(() => {
          closeSendModal();
        }, 3000);
      } else {
        setMessage(response.data?.errormsg || "Failed to send to device");
      }
    } catch (error) {
      console.error("Error sending to device:", error);
      setMessage("Error sending to device");
    } finally {
      setIsSending(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setModalFile("");
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000); // Clear the message after 3 seconds
      return () => clearTimeout(timer); // Cleanup the timer
    }
  }, [message]);

  return (
    <>
      <Menu />
      <div>
        <div className="wrapper">
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h1 className="mb-0">HTML Document</h1>
                    <div className="d-flex">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleAddPop}
                      >
                        Add Html File
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="card-body table-responsive p-0"
                  >
                    <section className="content">
                      <div className="container-fluid">
                        <hr />
                        <div className="row">
                          <div className="col-12">
                            <div className="card">
                              <div className="card-header"></div>

                              <div className="card-body table-responsive p-0">
                                <table className="table table-hover text-nowrap">
                                  <thead>
                                    <tr>
                                      <th>Id</th>
                                      {/* <th>HTML Document File</th> */}
                                      <th>Name</th>
                                      <th>File Description</th>
                                      <th>Active/Deactive</th>
                                      {/* <th>Up/Down</th> */}
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data.map((item, index) => (
                                      <Draggable
                                        key={item.id}
                                        draggableId={String(item.id)}
                                        index={index}
                                      >
                                        {(provided) => (
                                          <tr
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                          >
                                            <td>{item.id}</td>

                                            <td>{item.name}</td>
                                            <td>{item.remark}</td>
                                            <td>
                                              <Switch
                                                isOn={item.active}
                                                handleToggle={(e) => handleToggle(e, item)}
                                                id={item.id}
                                              />
                                            </td>
                                            {/* <td>
                                              <button
                                                type="button"
                                                className="btn btn-success mr-2"
                                                onClick={(e) =>
                                                  handlePosition(item.id, "up")
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  fill="currentColor"
                                                  className="bi bi-arrow-up"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path
                                                    fillRule="evenodd"
                                                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5A.5.5 0 0 0 8 15z"
                                                  />
                                                </svg>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={(e) =>
                                                  handlePosition(
                                                    item.id,
                                                    "down"
                                                  )
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  fill="currentColor"
                                                  className="bi bi-arrow-down"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path
                                                    fillRule="evenodd"
                                                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                                                  />
                                                </svg>
                                              </button>
                                            </td> */}
                                            <td>
                                              <button
                                                type="button"
                                                className="btn btn-primary btn-sm mr-2"
                                                onClick={() =>
                                                  handlePreview(item.id)
                                                }
                                                title="Preview"
                                              >
                                                <i className="fas fa-eye"></i>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-success btn-sm mr-2"
                                                onClick={() =>
                                                  handleDownload(item)
                                                }
                                                title="Download HTML file"
                                              >
                                                <i className="fas fa-download"></i>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-info btn-sm mr-2"
                                                onClick={() =>
                                                  handleUpdatePop(item.id)
                                                }
                                                title="Update"
                                              >
                                                <i className="fas fa-edit"></i>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() =>
                                                  handleDelete(item.id)
                                                }
                                                title="Delete"
                                              >
                                                <i className="fas fa-trash"></i>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-warning btn-sm ml-2"
                                                onClick={() => handleSendButtonClick(item.id)}
                                                title="Send"
                                              >
                                                <i className="fas fa-paper-plane"></i>
                                              </button>
                                            </td>
                                          </tr>
                                        )}
                                      </Draggable>
                                    ))}

                                    {provided.placeholder}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            {showModal && (
              <div
                className="modal"
                style={{
                  display: "block",
                  position: "fixed",
                  zIndex: 1050,
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                  outline: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
                onClick={closeModal}
              >
                <div
                  className="modal-dialog modal-lg"
                  style={{
                    maxWidth: "500px",
                    margin: "30px auto",
                    maxWidth: "300px",
                  }}
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">File Preview</h5>
                      <button
                        type="button"
                        className="close"
                        onClick={closeModal}
                      >
                        <span>&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <img
                        src={modalFile}
                        alt="HTML Document"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={closeModal}
                      >
                        Close
                      </button>
                      <CopyCommand path={modalFile} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isPopUpOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            backgroundColor: "white",
            boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
            zIndex: 1000,
          }}
        >
          <h2>Are you sure you want to switch the HTML document images?</h2>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 14,
            }}
          >
            <button
              type="button"
              className="btn btn-info mr-2"
              onClick={handleSwitch}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setIsPopUpOpen(false)}
            >
              No
            </button>
          </div>
        </div>
      )}

      {/* Other content */}
      {message === "Data deleted successfully!" ? (
        <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to delete data" ? (
        <FailedMessage message={message} />
      ) : (
        ""
      )}

      {message &&
        message !== "Data deleted successfully!" &&
        message !== "Failed to delete data" &&
        !message.includes("Position") ? (
        message.toLowerCase().includes("fail") ||
          message.toLowerCase().includes("error") ||
          message.toLowerCase().includes("not connected") ? (
          <FailedMessage message={message} />
        ) : (
          <SuccessMessage message={message} />
        )
      ) : (
        ""
      )}
      {/* Send Modal */}
      {showSendModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0,0,0,0.6)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document" style={{ width: "100%", maxWidth: "500px" }}>
            <div className="modal-content" style={{ borderRadius: "15px", border: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.2)" }}>
              <div className="modal-header" style={{ borderBottom: "1px solid #f0f0f0", padding: "1.5rem" }}>
                <h5 className="modal-title" style={{ fontWeight: "700", color: "#333", fontSize: "1.25rem" }}>
                  <i className="fas fa-paper-plane mr-2 text-primary"></i>
                  Send HTML Document
                </h5>
                <button type="button" className="close" onClick={closeSendModal} style={{ outline: "none" }}>
                  <span aria-hidden="true" style={{ fontSize: "1.5rem" }}>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ padding: "1.5rem" }}>
                {/* Type Selection Tabs */}
                <div style={{
                  display: "flex",
                  backgroundColor: "#f1f3f5",
                  borderRadius: "10px",
                  padding: "4px",
                  marginBottom: "1.5rem"
                }}>
                  <button
                    style={{
                      flex: 1,
                      padding: "10px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: sendType === "single" ? "#fff" : "transparent",
                      color: sendType === "single" ? "#007bff" : "#6c757d",
                      fontWeight: "600",
                      boxShadow: sendType === "single" ? "0 2px 8px rgba(0,0,0,0.1)" : "none",
                      transition: "all 0.2s ease",
                      cursor: "pointer"
                    }}
                    onClick={() => handleSendTypeChange({ target: { value: "single" } })}
                  >
                    <i className="fas fa-user mr-2"></i>Single POS
                  </button>
                  <button
                    style={{
                      flex: 1,
                      padding: "10px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: sendType === "group" ? "#fff" : "transparent",
                      color: sendType === "group" ? "#007bff" : "#6c757d",
                      fontWeight: "600",
                      boxShadow: sendType === "group" ? "0 2px 8px rgba(0,0,0,0.1)" : "none",
                      transition: "all 0.2s ease",
                      cursor: "pointer"
                    }}
                    onClick={() => handleSendTypeChange({ target: { value: "group" } })}
                  >
                    <i className="fas fa-users mr-2"></i>SubGroup
                  </button>
                </div>

                {sendType === "single" && (
                  <div className="animate__animated animate__fadeIn">
                    <div className="form-group mb-4">
                      <label style={{ fontWeight: "600", color: "#495057", marginBottom: "0.5rem", display: "block" }}>
                        <i className="fas fa-store mr-2 text-muted"></i>Select Merchant
                      </label>
                      {loadingMerchants ? (
                        <div className="d-flex align-items-center justify-content-center p-3">
                          <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                        </div>
                      ) : (
                        <select
                          className="form-control custom-select"
                          value={selectedMerchant}
                          onChange={handleMerchantChange}
                          style={{ borderRadius: "8px", padding: "0.6rem 1rem", height: "auto" }}
                        >
                          <option value="">Choose a Merchant...</option>
                          {merchants.map((m, index) => (
                            <option key={index} value={m.merchantid}>
                              {m.merchantid}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>

                    {selectedMerchant && (
                      <div className="form-group mb-0 animate__animated animate__fadeInUp">
                        <label style={{ fontWeight: "600", color: "#495057", marginBottom: "0.5rem", display: "block" }}>
                          <i className="fas fa-desktop mr-2 text-muted"></i>Select POS
                        </label>
                        {loadingPos ? (
                          <div className="d-flex align-items-center justify-content-center p-3">
                            <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                          </div>
                        ) : (
                          <select
                            className="form-control custom-select"
                            value={selectedPosId}
                            onChange={(e) => setSelectedPosId(e.target.value)}
                            style={{ borderRadius: "8px", padding: "0.6rem 1rem", height: "auto" }}
                          >
                            <option value="">Choose a POS Terminal...</option>
                            {posList.map((pos, index) => (
                              <option key={index} value={pos.id}>
                                {pos.value}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {sendType === "group" && (
                  <div className="animate__animated animate__fadeIn">
                    <div className="form-group mb-0">
                      <label style={{ fontWeight: "600", color: "#495057", marginBottom: "0.5rem", display: "block" }}>
                        <i className="fas fa-tags mr-2 text-muted"></i>Select Target Subgroups
                      </label>
                      <div style={{ position: "relative" }}>
                        {/* Dropdown Toggle */}
                        <div
                          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                          style={{
                            border: "1px solid #ced4da",
                            borderRadius: "10px",
                            padding: "12px 16px",
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            minHeight: "46px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            transition: "all 0.2s ease",
                            boxShadow: isDropdownOpen ? "0 0 0 3px rgba(0,123,255,0.15)" : "none",
                            borderColor: isDropdownOpen ? "#80bdff" : "#ced4da"
                          }}
                        >
                          <span style={{
                            color: selectedSubGroupshtmldoc.length === 0 ? "#999" : "#333",
                            fontWeight: selectedSubGroupshtmldoc.length > 0 ? "500" : "400"
                          }}>
                            {selectedSubGroupshtmldoc.length === 0
                              ? "Select subgroups..."
                              : `${selectedSubGroupshtmldoc.length} subgroup(s) selected`}
                          </span>
                          <i
                            className={`fas fa-chevron-${isDropdownOpen ? "up" : "down"}`}
                            style={{ color: "#6c757d", transition: "transform 0.3s" }}
                          ></i>
                        </div>

                        {/* Dropdown Menu */}
                        {isDropdownOpen && (
                          <div
                            style={{
                              position: "absolute",
                              top: "calc(100% + 8px)",
                              left: 0,
                              right: 0,
                              backgroundColor: "#fff",
                              border: "1px solid #e0e0e0",
                              borderRadius: "12px",
                              maxHeight: "280px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                              animation: "fadeInUp 0.2s ease-out"
                            }}
                          >
                            {groupList.length > 0 ? (
                              groupList.map((group) => (
                                <div key={group.id} style={{ borderBottom: "1px solid #f8f9fa" }}>
                                  {group.subgroupdata && group.subgroupdata.length > 0 && (
                                    <div>
                                      {/* Group Header */}
                                      <div
                                        onClick={() => handleGroupSelect(group.id)}
                                        style={{
                                          padding: "12px 16px",
                                          backgroundColor: "#f8f9fa",
                                          cursor: "pointer",
                                          fontWeight: "700",
                                          fontSize: "0.85rem",
                                          display: "flex",
                                          alignItems: "center",
                                          color: "#495057",
                                          textTransform: "uppercase",
                                          letterSpacing: "0.5px"
                                        }}
                                      >
                                        <div style={{ position: "relative", marginRight: "12px" }}>
                                          <input
                                            type="checkbox"
                                            checked={isGroupFullySelected(group.id)}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={() => handleGroupSelect(group.id)}
                                            ref={(input) => {
                                              if (input) {
                                                input.indeterminate = isGroupPartiallySelected(group.id);
                                              }
                                            }}
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              cursor: "pointer",
                                              accentColor: "#007bff"
                                            }}
                                          />
                                        </div>
                                        <i className="fas fa-folder mr-2" style={{ color: "#ffc107" }}></i>
                                        {group.name}
                                        <span style={{
                                          marginLeft: "auto",
                                          fontSize: "0.75rem",
                                          backgroundColor: "#e9ecef",
                                          padding: "2px 8px",
                                          borderRadius: "10px",
                                          color: "#6c757d"
                                        }}>
                                          {group.subgroupdata.length}
                                        </span>
                                      </div>

                                      {/* Subgroups */}
                                      {group.subgroupdata.map((subgroup) => (
                                        <div
                                          key={subgroup.id}
                                          onClick={() => handleSubGroupSelect(subgroup.id)}
                                          style={{
                                            padding: "10px 16px 10px 48px",
                                            cursor: "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            backgroundColor: selectedSubGroupshtmldoc.includes(subgroup.id) ? "#f0f7ff" : "#fff",
                                            transition: "background-color 0.2s"
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedSubGroupshtmldoc.includes(subgroup.id)}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={() => handleSubGroupSelect(subgroup.id)}
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                              marginRight: "12px",
                                              cursor: "pointer",
                                              accentColor: "#007bff"
                                            }}
                                          />
                                          <i className="fas fa-layer-group mr-2" style={{ color: "#adb5bd", fontSize: "12px" }}></i>
                                          <span style={{
                                            fontSize: "0.9rem",
                                            color: selectedSubGroupshtmldoc.includes(subgroup.id) ? "#007bff" : "#495057",
                                            fontWeight: selectedSubGroupshtmldoc.includes(subgroup.id) ? "600" : "400"
                                          }}>
                                            {subgroup.name}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              ))
                            ) : (
                              <div style={{ padding: "30px", textAlign: "center", color: "#adb5bd" }}>
                                <i className="fas fa-info-circle mb-2 d-block" style={{ fontSize: "1.5rem" }}></i>
                                No subgroups available
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Selected Items Display */}
                      {selectedSubGroupshtmldoc.length > 0 && (
                        <div
                          style={{
                            marginTop: "1.25rem",
                            padding: "1rem",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "12px",
                            border: "1px dashed #dee2e6"
                          }}
                        >
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", maxHeight: "120px", overflowY: "auto" }}>
                            {getSelectedSubGroupNames().map((name, index) => (
                              <span
                                key={index}
                                style={{
                                  backgroundColor: "#e7f3ff",
                                  border: "1px solid #c2e0ff",
                                  borderRadius: "6px",
                                  padding: "4px 10px",
                                  fontSize: "0.75rem",
                                  color: "#0061c2",
                                  fontWeight: "600",
                                  display: "flex",
                                  alignItems: "center"
                                }}
                              >
                                {name}
                                <i className="fas fa-times ml-2" style={{ fontSize: "0.6rem", opacity: 0.5, cursor: "pointer" }} onClick={(e) => {
                                  e.stopPropagation();
                                  // Find the subgroup ID from the name and remove it
                                  let subId;
                                  groupList.forEach(g => g.subgroupdata?.forEach(sg => { if (sg.name === name) subId = sg.id; }));
                                  if (subId) handleSubGroupSelect(subId);
                                }}></i>
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer" style={{ borderTop: "1px solid #f0f0f0", padding: "1.25rem 1.5rem", justifyContent: "space-between" }}>
                <button
                  type="button"
                  className="btn"
                  onClick={closeSendModal}
                  style={{ fontWeight: "600", color: "#6c757d", padding: "0.6rem 1.5rem" }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSetToDevice}
                  disabled={
                    isSending ||
                    (sendType === 'single' && (!selectedMerchant || !selectedPosId)) ||
                    (sendType === 'group' && selectedSubGroupshtmldoc.length === 0)
                  }
                  style={{
                    fontWeight: "700",
                    padding: "0.6rem 2rem",
                    borderRadius: "10px",
                    boxShadow: "0 4px 12px rgba(0,123,255,0.3)",
                    transition: "transform 0.2s"
                  }}
                >
                  {isSending ? (
                    <><span className="spinner-border spinner-border-sm mr-2" role="status"></span>Sending...</>
                  ) : (
                    <><i className="fas fa-cloud-upload-alt mr-2"></i>Set to device</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShowHtmlDoc;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
